export { default } from './SocialMediaShortcuts'